module.exports = __webpack_public_path__ + "static/img/shcszwy_2.3c8a3ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/shcszwy_2.png
// module id = a7lz
// module chunks = 15